import type { CreatePriceAlarmRequest, PriceAlarm, UpdatePriceAlarmRequest } from '../../types/api';
import { apiFetch, apiRequest } from './client';

export function fetchAlarms(): Promise<PriceAlarm[]> {
  return apiFetch<PriceAlarm[]>('/api/alarms');
}

export function createAlarm(alarm: CreatePriceAlarmRequest): Promise<PriceAlarm> {
  return apiFetch<PriceAlarm>('/api/alarms', {
    method: 'POST',
    body: JSON.stringify(alarm),
  });
}

export function updateAlarm(id: string, alarm: UpdatePriceAlarmRequest): Promise<PriceAlarm> {
  return apiFetch<PriceAlarm>(`/api/alarms/${encodeURIComponent(id)}` as `/api/${string}`, {
    method: 'PATCH',
    body: JSON.stringify(alarm),
  });
}

export function deleteAlarm(id: string): Promise<void> {
  return apiRequest(`/api/alarms/${encodeURIComponent(id)}` as `/api/${string}`, {
    method: 'DELETE',
  });
}
